var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 80.0508C0 31.4346 38.826 0 81.7389 0C122.608 0 159.8 28.5059 163.171 73.2172H186.876C191.473 73.2172 193.721 78.4889 190.452 81.5152L156.837 113.633C154.793 115.586 151.626 115.586 149.582 113.633L115.967 81.5152C115.267 80.833 114.792 79.9694 114.601 79.0316C114.409 78.0937 114.51 77.1229 114.891 76.2394C115.272 75.3559 115.916 74.5986 116.743 74.0614C117.569 73.5242 118.543 73.2307 119.543 73.2172H142.634C139.467 41.3921 113.719 19.5246 81.7389 19.5246C47.5108 19.5246 20.4347 44.6137 20.4347 80.0508C20.4347 102.895 40.3586 133.158 81.7389 169.278C88.2781 163.519 94.3063 157.954 99.8237 152.585C98.0258 149.195 97.0811 145.451 97.065 141.651C97.065 135.178 99.7562 128.97 104.546 124.393C109.337 119.817 115.834 117.245 122.608 117.245C129.383 117.245 135.88 119.817 140.67 124.393C145.461 128.97 148.152 135.178 148.152 141.651C148.148 145.426 147.225 149.149 145.456 152.524C143.686 155.899 141.119 158.835 137.957 161.098C134.795 163.362 131.125 164.891 127.237 165.566C123.35 166.24 119.351 166.04 115.558 164.983C107.589 172.988 98.4954 181.188 88.4824 189.584C84.5998 192.805 78.7759 192.805 74.8933 189.584C25.0325 147.606 0 111.095 0 80.0508Z",
    fill: "none",
    className: "primary"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoad);
export default __webpack_public_path__ + "static/media/icon_road.a92dabf1.svg";
export { ForwardRef as ReactComponent };